import Block from '../block'

export default class ShoppingcartPopupButton extends Block {
	static title = 'shoppingcart-popup-button'

	init() {
		this.buttonCount = this.getElement('count')
		this.buttonTotal = this.getElement('total')

		this.itemsText = this.getElement('items')

		this.eventEmitter.on('shoppingcart-popup:update', payload =>
			this.updateButton(payload.count, payload.total)
		)

		this.element.addEventListener('click', () => this.toggleShoppingcartPopup())
	}

	updateCount(count) {
		if (!this.buttonCount) {
			return
		}

		this.buttonCount.textContent = count
	}

	updateTotal(total) {
		if (!this.buttonTotal) {
			return
		}

		this.buttonTotal.textContent = total
	}

	updateButton(count, total) {
		this.updateCount(count)
		this.updateTotal(total)

		if (!this.itemsText) {
			return
		}

		if (parseInt(count, 10) !== 1) {
			this.itemsText.textContent = 'items'
			return
		}

		this.itemsText.textContent = 'item'
	}

	toggleShoppingcartPopup() {
		this.eventEmitter.emit('shoppingcart-popup-button:toggle')
	}
}
